<script lang="ts" setup>
import { DModal, CircleIcon, CheckCircleIcon } from 'front-library'

defineProps<{
  modalActive: boolean | undefined
  roles: any
  userRole: any
}>()

const emit = defineEmits(['change:role', 'close'])

const emitChangeRole = (code: string) => {
  emit('change:role', code)
}

const emitClose = () => {
  emit('close')
}
</script>
<template>
  <DModal
    size=""
    :open="modalActive"
    title="Roles disponibles"
    @closeModal="emitClose()">
    <template #description>
      <div class="sm:px-8 flex-col gap-4 w-80 sm:w-full">
        <hr class="mt-1 mb-5" />
        <div
          v-for="role in roles"
          :key="(role as any).code"
          class="w-72 sm:w-96 h-12 cursor-pointer border border-transparent hover:border-blue-600 flex justify-start items-center rounded-lg px-5 my-1 mx-auto"
          :class="
            (role as any).code == userRole ? 'text-white bg-blue-600' : 'text-blue-600'
          "
          @click="emitChangeRole((role as any).code)">
          <CheckCircleIcon
            v-if="(role as any).code == userRole"></CheckCircleIcon>
          <CircleIcon v-else></CircleIcon>
          <div class="ml-4">{{ (role as any).name }}</div>
        </div>
      </div>
    </template>
  </DModal>
</template>
